export default __webpack_public_path__ + "static/media/ic-time.aa3dce45.svg";